// extracted by mini-css-extract-plugin
export default {"container_cart":"Cart_container_cart__SeI6g"};